/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.product_card
 */
function productCardDirective() {
    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        // initial call
        scope: {
            product: '=',
            onCardClick: '&',
            dailyMileage: '=?',
            recommendationType: '=?'
        },
        controller: productCardController,
        link: link,
        template: '<div ng-include="getContentUrl()"></div>'
    };
}

function link(scope, elem, attrs, controller) {
    scope.getContentUrl = function() {
        // TODO: change this to use a category setting instead of going off category_type
        var cardType = scope.category.category_type === 'base' ? 'marketplace' : 'simplified';
        if (scope.category.category_code === 'cars') {
            cardType = 'cars';
        }
        return '/common_utils/product_card/2018/' + cardType + 'CardView.html';
    };
    scope.elem = elem;
    scope.$emit("card_ready");
}

productCardController.$inject = [
    '$scope',
    '$state',
    '$window',
    'AnalyticsService',
    'CategoriesService',
    'GetFetchService',
    'ProductCardService',
    'ProductService',
    'RebatesService',
    'UtilService',
    'ProductCompareService'
];
function productCardController (
    $scope,
    $state,
    $window,
    AnalyticsService,
    CategoriesService,
    GetFetchService,
    ProductCardService,
    ProductService,
    RebatesService,
    UtilService,
    ProductCompareService
) {
    $scope.allowEasyRebate = UtilService.isFeatureEnabled('easy_rebate_claim');

    $scope.openLinkNewWindow = UtilService.openLinkNewWindow;

    $scope.isMobile = UtilService.isMobile();

    $scope.offersBoxIsVisible = false;
    $scope.descriptionBoxIsVisible = false;

    $scope.product.fullName = ProductService.getFullName($scope.product);

    $scope.category = CategoriesService.getCategoryById($scope.product.category_id);
    $scope.product.category = $scope.category;

    $scope.offersMessageIsVisible = false;

    // Product compare feature enabled and not show on index page
    $scope.showComparison = ProductCompareService.isComparisonEnabled && UtilService.getPageType() !== "indexPage";

    /**
     * Tracks the event and redirects to the new page
     * @param link
     */
    $scope.redirectToWebsite = function (link) {
        AnalyticsService.reportEvent('Visit Website Clicked', {source: $state.current.name}, $scope.product);
        $window.open(link, '_blank');
    };

    $scope.product.productLink = $state.href('product', {
        category_code: $scope.category.category_code,
        product_info: $scope.product.link
    });
    $scope.compareProductLink = $state.href('product', {
        category_code: $scope.category.category_code,
        product_info: $scope.product.link_from_name,
        section: "product-compare"
    });

    $scope.storeClickedProduct = function () {
        if ($scope.isStatic) {
            return;
        }

        GetFetchService.update("clickedProduct", $scope.product);
        if ($scope.onCardClick) {
            $scope.onCardClick();
        }
        var tracking_data = {
            source: $state.current.name
        };
        if ($scope.category.category_code === 'cars') {
            tracking_data.battery_range_shown = !!$scope.product.all_electric_range;
            tracking_data.recommended_battery_range = !!$scope.goodBatteryRange;
        }
        AnalyticsService.reportEvent('Product Selected', tracking_data, $scope.product);
    };

    $scope.toggleOffersMessage = function () {
        $scope.product.offersMessageIsVisible = !$scope.product.offersMessageIsVisible;
        if ($scope.product.offersMessageIsVisible) {
            UtilService.focusElement($scope.elem.find('.card-hide-offers-disclaimer-btn'));
        } else {
            UtilService.focusElement($scope.elem.find('.card-show-offers-disclaimer-btn'));
        }
    };

    $scope.hideOffersBox = function () {
        $scope.product.offersBoxIsVisible = false;
        UtilService.focusElement($scope.elem.find('.card-show-offers-btn'));
    };

    $scope.showDescriptionBox = function () {
        $scope.descriptionBoxIsVisible = true;
    };

    $scope.hideDescriptionBox = function () {
        $scope.descriptionBoxIsVisible = false;
    };

    function getCardAriaText(text) {
        $scope.cardAriaText = text;
    }

    ProductCardService.setTextUpdatedCallback($scope.product.id, getCardAriaText);
}

module.exports = productCardDirective;
